import { BankAccountAttributes, BankAccountSalesOfficeAccountingAttributes, BankAttributes, PaymentTypeAttributes, ShortCurrencyAttributes } from '@albatrosdeveloper/ave-models-package';
import { BankAccountTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/bank-account-type.enum";
import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BankAccountService } from './account.service';
import { IAPIListResult, IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { ICreateBankAccount } from './interfaces/create-account.interface';
import { IUpdateBankAccount } from './interfaces/update-account.interface';
import { CurrencyService } from 'app/modules/components/master/currency/currency.service';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import ShortPaymentTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-type-short/payment-type.short.entity';
import { PaymentTypeService } from '../../payment-type/payment-type.service';
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';
import { SalesOfficesFormComponent } from '../../account-sales/account-sales.component';
import { BankAccountSalesOfficeService } from './account-bank-sales.service';
import { DialogDataAccountSalesBase, PayloadAccountSalesBasic } from '../../account-sales/interfaces/account-sales.interface';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {
  displayedColumns: string[] = [
    "accountNumber",
    "currency",
    "commission",
    "type",
    "action"
  ];

  dataSource = new MatTableDataSource<BankAccountAttributes>([]);

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof BankAccountAttributes = "accountNumber";
  sortDirection: "ASC" | "DESC" = "ASC";

  currencyList: ShortCurrencyAttributes[] = []
  currencyFilterList: ShortCurrencyAttributes[] = []
  typeBankAccountList: string[] = Object.values(BankAccountTypeEnum)

  currentCreateBankAccount: ICreateBankAccount = this.initializeCreateBankAccount();
  currentUpdateBankAccount: IUpdateBankAccount | undefined;

  paymentTypeList: PaymentTypeAttributes[] = []
  paymentTypeFilterList: PaymentTypeAttributes[] = []

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  constructor(
    private bankAccountService: BankAccountService,
    private readonly currencyService: CurrencyService,
    private readonly paymentTypeService: PaymentTypeService,
    private readonly bankAccountSalesOfficeService: BankAccountSalesOfficeService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AccountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BankAttributes
  ) { }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
      this.getList()
    }
  }

  getList(): void {
    //let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.bankAccountService.getAllBankAccount(String(this.data._id)).subscribe({
      next: (res: IAPIListResult<BankAccountAttributes>) => {
        this.dataSource.data = res?.data ?? [];
        this.totalItems = res?.data?.length ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener cuentas de banco.","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateBankAccount(): ICreateBankAccount {
    return {
      accountNumber: "",
      commission: 0,
      currencyId: [],
      paymentTypeId: [],
      type: null,
      accountingAccount: '',
      accountingKey: '',
      costCenter: '',
      taxRetainment: 0
    };
  }

  getAllCurrencies(): void {
    this.currencyService.findToComboBox().subscribe({
      next: (res: IRequestResult<ShortCurrencyAttributes[]>) => {
        this.currencyList = res.data;
        this.currencyFilterList = this.currencyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener monedas.","Cerrar",{ duration: 5000});
      }
    });
  }

  getAllPaymentType(): void {
    let method = ['MP00008', 'MP00007'];
    this.paymentTypeService.findToComboBox(method).subscribe({
      next: (res: IRequestResult<PaymentTypeAttributes[]>) => {
        this.paymentTypeList = res.data;
        this.paymentTypeFilterList = this.paymentTypeList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipos de pago.","Cerrar",{ duration: 5000});
      }
    });
  }


  getBankAccountTypeLabel(bankAccountType: string): string {
    const labels = {
      [BankAccountTypeEnum.CHECKING]: 'Cuenta Monetaria',
      [BankAccountTypeEnum.SAVINGS]: 'Cuenta de Ahorros',
      [BankAccountTypeEnum.TRANSFERS]: 'Cuenta de Transferencias'
    };
    return labels[bankAccountType] || bankAccountType
  }

  openCreateModal(): void {
    this.getAllCurrencies();
    this.getAllPaymentType();
    this.currentCreateBankAccount = this.initializeCreateBankAccount();
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: '90%', disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBankAccount());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(bankAccount: BankAccountAttributes): void {
    this.getAllCurrencies();
    this.getAllPaymentType();
    this.currentUpdateBankAccount = {
      ...bankAccount,
      currencyId: bankAccount.currency ? bankAccount?.currency.map(a => a?._id?.toString()) : [],
      paymentTypeId: bankAccount.paymentType ? bankAccount?.paymentType.map(a => a?._id.toString()) : []
    };
    this.dialogRefEdit = this.dialog.open(this.editModal, { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateBank(bankAccount._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBankAccount(): void {
    this.bankAccountService.createEmbedded(String(this.data._id), this.currentCreateBankAccount).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.getList();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateBank(id: string): void {
    if (this.currentUpdateBankAccount) {
      const updatedBank: IUpdateBankAccount = { ...this.currentUpdateBankAccount };

      this.bankAccountService.updateEmbedded(String(this.data._id), id, updatedBank).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.getList();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, bank: BankAccountAttributes): void {
    const originalStatusId = bank.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBank = { ...bank, statusId: updatedStatusId };

    this.bankAccountService.update(bank._id.toString(), updatedBank).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        bank.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(bank: BankAccountAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: bank, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(bank._id.toString()));
  }

  delete(id: string): void {
    this.bankAccountService.deleteEmbedded1d(String(this.data._id), id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  openAccountSaleOffice(bank: BankAccountAttributes){
    this.dialog.open(SalesOfficesFormComponent, {
      width: '90%',
      data: {
        title: 'Determinación de Cuentas',
        crudService: this.bankAccountSalesOfficeService,
        fatherId: String(this.data._id),
        element: bank
      } as DialogDataAccountSalesBase<BankAccountSalesOfficeAccountingAttributes>
    });
  }
}
